<template>
  <div>
    <div class="paihang_box">
      <div class="content1">
        <div class="paihang_title">“城市交通+法规标准知识” 赛题当前部分排行</div>
        <table>
            <thead>
              <tr>
                <th rowspan="3">当前排名</th>
                <th rowspan="3">队伍</th>
                <th rowspan="3">队长</th>
                <th rowspan="3">所属单位</th>
                <th colspan="7">城市交通+法规标准知识</th>
                <th rowspan="3">Avg</th>
              </tr>
              <tr>
                <th>交通信号知识问答</th>
                <th>交通执勤执法问答</th>
                <th>交通违法行为问答</th>
                <th>车辆管理知识问答</th>
                <th>驾驶员管理问答</th>
                <th>道路交通安全问答</th>
                <th>交通事故处理问答</th>
              </tr>
              <tr>
                <th>50题</th>
                <th>50题</th>
                <th>50题</th>
                <th>50题</th>
                <th>50题</th>
                <th>30题</th>
                <th>20题</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in rankList" :key="index">
                <td>{{ item['当前排名'] }}</td>
                <td>{{ item['队伍'] }}</td>
                <td>{{ item['队长'] }}</td>
                <td>{{ item['所属单位'] }}</td>
                <td>{{ item['交通信号知识问答'] }}</td>
                <td>{{ item['交通执勤执法问答'] }}</td>
                <td>{{ item['交通违法行为问答'] }}</td>
                <td>{{ item['车辆管理知识问答'] }}</td>
                <td>{{ item['驾驶员管理问答'] }}</td>
                <td>{{ item['道路交通安全问答'] }}</td>
                <td>{{ item['交通事故处理问答'] }}</td>
                <td>{{ item['Avg'] }}</td>
              </tr>
            </tbody>
        </table>
        <!-- <p class="des">（本赛道第一期已截止）</p> -->
      </div>
    </div>
    <div class="previous_box1">
      <div class="previous_box1_title1">
        “城市交通+法规标准知识” 赛题介绍
        <div class="previous_box1_title1_line"></div>
      </div>
      <div class="previous_box1_title1_content">
        <p>
          大模型在智能交通领域的巨大潜力和相应风险，引起了业界对其专业性能评估的迫切需求。为了准确评估交通大模型在交通法规标准知识领域的能力，促进智能交通大模型的研究，我们从实际交通管理的角度出发，以一线工作者（如交通执法人员、交通信号控制人员）处理、思考和解决问题为基准，构建了一个全面的评估框架。该框架包含六个能力层次的多个任务，实现对大模型在交通法规知识能力上的初步评价。
        </p>
        <p>
          通过城市交通法规标准知识赛道，旨在推动交通大模型技术的发展，提高其在智能交通业务中的实用性和可靠性。同时，通过基准测试大赛形式，促进行业内的交流与合作，共同探索智能交通领域的创新解决方案。
        </p>
        <p>
          该赛道由佳都科技承办、中国交通信息科技集团、广东省交通集团有限公司智慧交通研发中心协办，广州市交警支队作为合作单位。
        </p>
        <!-- <div class="previous_png1"></div> -->
      </div>

      <div class="previous_box1_title2">
        任务介绍
        <div class="previous_box1_title2_line"></div>
      </div>
      <!-- <div class="previous_box1_title2_content"> -->
      <div class="previous_box1_title1_content">
        <!-- <p>
          <span>交通概念问答：</span
          >测试模型对于交通概念的记忆能力，通过问模型一个基础的交通概念，看模型是否能回答正确；问题格式为包含A/B/C/D这4个选项的单选题或者判断正确/错误的判断题；如"请判断下面的说法是否正确？只需要回答正确或错误即可；汽车吊车及其他轮式专用机械车允许牵引1辆挂车。请从下面的A、B、C、D四个答案中给问题选出一个正确答案；只需要回答选项名A或B或C或D即可；高速公路限速标志标明的最高时速不得超过多少公里？“A.120公里&emsp;&emsp;B.90公里&emsp;&emsp;C.100公里&emsp;&emsp;D.140公里”
        </p>
        <p>
          <span>交通规则问答：</span
          >测试模型对于交通规则的记忆能力，问题都是关于具体的交通规则，如车辆行驶相关规则、车辆管理相关规则等；问题格式包含单选题和判断题。
        </p>
        <p>
          <span>交通标志问答：</span
          >测试模型对于交通标志的记忆能力，给模型一张交通标志图和一个问题，模型需要明白该交通标志的具体含义同时做出正确的回答；问题格式包含单选题和判断题。
        </p>
        <p>
          <span>交通事故分析：</span
          >给模型一段交通事故描述的文本或者一张交通事故的图片，模型需要能从中分析出该交通事故发生的具体原因。
        </p>
        <p>
          <span>交通公众舆情分析：</span
          >给模型提供社会公众对于新颁发的交通规则/政策的意见或者对现有交通设置的不满，模型需要从中分析和总结出公众的真实诉求。
        </p>
        <p>
          <span>交通安全建议：</span
          >给模型提供出行计划或出行天气状况，模型可以提供合理的出行安全建议；给模型提供相关驾驶场景的图片，模型能分析出存在的交通安全隐患并提供合理的安全建议。
        </p>
        <p>
          <span>交通标志错误检测：</span
          >给模型提供交通标志图（交通标志线/交通指示牌等），模型可以分析出交通标志线的绘制或交通标识的设置是否合理，是否存在错误。
        </p>
        <p>
          <span>道路占用监测：</span
          >给模型道路的图片或者轨道的相关图片，模型可以分析道路是否存在非法占用的情形。
        </p>
        <p>
          <span>交通应急预案生成：</span
          >针对用户提出的不同场景，模型需要能生成合理的应急预案。
        </p>
        <p>
          <span>交通安全教育文案生成：</span
          >针对用户给出的不同受众群体和安全教育场景，模型需要能生成合理有用的安全教育文案。
        </p> -->
        <!-- <div class="chart"></div> -->
         <!-- <p>
          该评估框架专注于城市交通赛道的特定需求，旨在评估大模型在处理车辆管理、驾驶员管理、违法处理规范、交通执法规范、交通信号控制等方面的能力。通过业务场景的知识问答任务，可以深入理解交通大模型在遵守和执行交通法规方面的表现，为智能交通系统的安全和效率提供保障。
         </p> -->
         <p>
          该评估框架专注于城市交通赛道的特定需求，旨在评估大模型在交通信号知识、交通执勤执法规范知识、交通违法行为知识、车辆管理知识、驾驶员管理知识、道路交通安全知识和交通事故处理知识等方面知识的能力。通过结合业务场景的知识问答任务，可以深入理解交通大模型在遵守和执行交通法规方面的表现，为智能交通系统的安全和效率提供保障。
         </p>
      </div>

      <div class="previous_box1_title2">
        评测指标
        <div class="previous_box1_title2_line"></div>
      </div>
      <div class="previous_box1_title1_content">
        <!-- <p>
          本任务的评价方式由三个部分组成：选择题、判断题、开放式问答题。
        </p>
        <p>
          其中选择题和判断题的评分都是采用模型所有题目回答的准确率作为得分；
        </p>
        <p>
          开放式问答题则通过计算答案和模型回答之间的余弦相似度值，如果值大于或等于0.75，则认为该回答为正确（得1），否则错误（得0）。最终开放式问答题得分为所有题目的准确率。
        </p>
        <p>
          因此，总分计算公式为：
        </p>
        <p>
          score = (选择题正确总数/100 + 判断题正确总数/100 + 开放式问答题正确总数/100) / 3
        </p> -->
        <p>
          本任务采用开放式问答方式来对大模型进行评估，总计300道问答题。
        </p>
        <p>
          每道题目得分均通过GPT-4对大模型的回答，从准确性、相关性、帮助性、完整度四个维度指标对比参考答案，进行0-10分的打分。若打分大于或等于7.5分，则认为该道题是回答正确的；否则，该道题回答错误。每个主题的得分为该主题下所有题目的回答正确率。
        </p>
        <p>
          赛道3评测总得分计算公式为：
        </p>
        <p>
          score = 交通信号知识正确率*权重+ 交通执勤执法正确率*权重+ 交通违法行为正确率*权重+ 车辆管理知识正确率*权重+ 驾驶员管理正确率*+ 道路交通安全正确率*权重+ 交通事故处理正确率*权重
        </p>
      </div>
      <!-- <div class="previous_box1_title2">
        评测流程
        <div class="previous_box1_title2_line"></div>
      </div>
      <div class="previous_box1_title1_content">
        <p>
          为了防止数据的直接泄漏，我们需要在您注册后提交申请测评的请求（单模态数据集和多模态数据集需要分开申请），同时您必须同意数据集的使用规范，然后我们将发送给您测试数据集，您得到结果后从网站提交您的结果；我们将尽快为您计算您模型的得分情况，无特殊要求外，我们会将测评结果添加到排行榜上。
        </p>
        <p><br /></p>
        <p>如果您想参与测评，您需要做：</p>
      </div> -->

    </div>
    <div class="previous_box2">
      <!-- <div class="previous_box2_title1">
        评测指标
        <div class="previous_box2_title1_line"></div>
      </div>
      <div class="previous_box2_title1_content">
        <p>
          <span>Accuracy：</span>
          对于有标准答案的单选题和判断题（T1～T3任务），我们抽取出模型预测中的相关答案后，根据标准答案计算Accuracy；
        </p>
        <p>
          <span>ROUGE：</span>
          对于文本生成类的任务（T4～T10任务），我们计算模型预测答案和参考答案的ROUGE-Chinese-L分数；
        </p>
        <p>
          <span>GPT-4-Eval：</span>
          对于文本生成类的任务（T4～T10任务），考虑到正确答案的不唯一性，我们调用GPT-4从答案的正确性/冗余性/流畅度/完整性这四个方面对模型预测的答案进行打分；
        </p>
      </div> -->

      <div class="previous_box2_title2">
        评测流程
        <div class="previous_box2_title2_line"></div>
      </div>
      <div class="previous_box2_title2_content">
        <p>
          本赛道不下发测评数据，请按下述结果提交要求提交模型接口。
        </p>
        <p>
          1、原则上不可用业界的（闭源）通用大模型API直接进行参赛;
        </p>
        <p>
          2、单个参赛选手，可重复提交进行评测，但原则上同一评测周期内提交不可超过2次；
        </p>
      </div>
    </div>

    <div class="previous_box3">
      <div class="bigBtnBox">
        <div class="btns">
          <!-- <div class="btn1" @click="apply">申请评测</div> -->
          <div class="btn1" @click="apply">申请评测</div>
        </div>
        <div class="btns">
          <!-- <div class="btn2" @click="isShow = true">结果上传</div> -->
          <div class="btn2" @click="tips">结果上传</div>
        </div>
        <div class="btns">
          <div class="btn3">当前排行榜</div>
        </div>
      </div>

      <div class="previous_box3_title1">
        结果提交介绍
        <div class="previous_box3_title1_line"></div>
      </div>
      <!-- <div class="previous_box3_title1_content">
        <p>本任务评测提供的测试集均由人工根据相关业务场景知识构建，测试集构成如下：</p>
        <p>选择题100道、判断题100道、开放式问答题100道。</p>
      </div> -->
      <!-- <div class="previous_box3_title1">
        结果提交介绍
        <div class="previous_box3_title2_line"></div>
      </div> -->
      <div class="previous_box3_title1_content">
        <p>需要提交模型部署的HTTP服务地址和端口。</p>
        <p>例如：</p>
        <p>流式URI：/api/gpt/chat/completions/stream</p>
        <p>非流式URI：/api/gpt/chat/completions</p>
        <p></p>
        <p>模型接受请求的body格式：</p>
        <p>body = {</p>
        <p>"model": "xxx",  #模型的名称</p>
        <p>"max_tokens": 8192,  #模型支持的最大token数</p>
        <p>"top_p": 0.8,  #模型生成文本准确性和多样性的参数</p>
        <p>"temperature": 0.8,  #温度参数</p>
        <p>"top_k": 30,  #模型限制考虑候选词数量的参数</p>
        <p>"repetition_penalty": 3,  #重复惩罚参数</p>
        <p>"messages": “xxx”  #信息内容</p>
        <p>}</p>
        <!-- <p>说明：</p>
        <p>“model”：为模型的名称；</p>
        <p>“max_tokens”：为模型支持的最大token数；</p>
        <p>“top_p”：为模型生成文本准确性和多样性的参数；</p>
        <p>“temperature”：温度参数；</p>
        <p>“top_k”：为模型限制考虑候选词数量的参数；</p>
        <p>“repetition_penalty”：为重复惩罚参数；</p>
        <p>“messages”：为信息内容；</p> -->
      </div>

      <div class="previous_box3_title2">
        赛程安排
        <div class="previous_box3_title2_line"></div>
      </div>

      <!-- <div class="arrange">
        <ul>
          <li>
            <p class="frist_title">注册账号</p>
            <div class="frist_div">
              <div>2024.7.11</div>
              <div>-</div>
              <div>2024.7.30</div>
            </div>
          </li>
          <li>
            <p>提交相应的测评申请</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
          <li>
            <p>同意数据使用协议</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
          <li>
            <p>拿到数据后对模型进行测试</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
          <li>
            <p>按照规定格式上传您的结果</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
        </ul>
      </div> -->

      <div class="previous_box3_title1_content">
        <p>提交：截止至12月2日
        </p>
        <p>评审：截止至12月4日
        </p>
        <p>公示：12月4日
        </p>
        <p>颁奖：12月8日
        </p>
      </div>

      <div class="previous_box3_title3">
        奖金设置
        <div class="previous_box3_title3_line"></div>
      </div>
      <div class="previous_box3_content">
        <div>
          <div class="bonus1">
            <p class="bonus1-text">1名 奖金15000元</p>
          </div>
        </div>
        <div>
          <div class="bonus2">
            <p class="bonus2-text">2名 奖金7500元</p>
          </div>
        </div>
        <div>
          <div class="bonus3">
            <p class="bonus3-text">3名 奖金5000元</p>
          </div>
        </div>
      </div>

      <div class="previous_box3_title1_content">
        <p>注：以上所有提及金额均为税前金额。
        </p>
        <p>
          获奖算法与系统的知识产权归参赛队伍所有，仅要求获奖团队提供算法与系统报告（包括方法说明、数据处理、参考文献和使用开源工具等信息）及团队成员名单，供颁奖会技术交流.
        </p>
        <p>
          由主办方为获奖者提供荣誉证书认证；由承办单位为获奖者提供奖金支持。
        </p>
      </div>
    </div>

    <div class="box3">
      <div class="title4">
        分赛道组织单位
        <div class="title4_line"></div>
      </div>
      <!-- <div class="dw">承办单位</div> -->
      <!-- <div></div> -->
      <!-- <mainUnits class="slot1">
        <template v-slot:picture>
          <img style="height: 100%; width: 100%" src="" alt="" />
        </template>
        <template v-slot:content>中国中文信息学会大模型与生成专委会</template>
        <template v-slot:english>
          <p style="margin-left: -0.45rem; text-wrap: nowrap;">
            Large Model and Generation Committee of Chinese Information Pro
          </p>
        </template>
      </mainUnits> -->
      <!-- <mainUnits class="slot2">
        <template v-slot:picture>
          <img style="height: 100%; width: 100%" src="" alt="" />
        </template>
        <template v-slot:content> 北京交通大学 </template>
        <template v-slot:english> Beijing Jiaotong University </template>
      </mainUnits> -->
      <div class="title5">承办单位</div>
      <div class="xb">
        <!-- <div>
          <mainUnits class="cb_slot1">
            <template v-slot:picture>
              <img style="height: 100%; width: 100%" src="" alt="" />
            </template>
            <template v-slot:content> 北京大学 </template>
            <template v-slot:english>Peking university</template>
          </mainUnits>
        </div> -->
        <div>
          <mainUnits class="div1">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 佳都科技集团股份有限公司 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
        <div></div>
      </div>
      <div class="title6">协办单位</div>
      <div class="xb">
        <div>
          <mainUnits class="div2">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 中国交通信息科技集团有限公司 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
        <div>
          <mainUnits class="div3">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 广东省交通集团有限公司智慧交通研发中心 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
      </div>
      <div class="title6">合作单位</div>
      <div class="xb">
        <div>
          <mainUnits class="div1">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 广州市公安局交通警察支队 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
      </div>
      <div class="title6">评测委员</div>
      <div class="container">
      <div class="left">
        <div class="item">
          <h3 class="name">王凯</h3>
          <p>佳都科技集团</p>
          <p>首席AI科学家</p>
        </div>
        <div class="item">
          <h3 class="name">王晶</h3>
          <p>中国交通信息科技集团有限公司</p>
          <p>技术总监</p>
        </div>
        <div class="doublename">
          <div class="item1">
            <h3 class="name">邢万勇</h3>
            <p>广东省交通集团有限公司智慧交通研发中心</p>
            <p>主任</p>
          </div>
          <div class="item2">
            <h3 class="name">林成创</h3>
            <p>广东省交通集团有限公司智慧交通研发中心</p>
            <p>AI业务创新总监</p>
          </div>
        </div>
        <div class="item">
          <h3 class="name">黄伟涛</h3>
          <p>广州市公安局交通警察支队</p>
          <p></p>
        </div>
      </div>
    </div>
    </div>

    <!-- <div class="gameButtomBg">
      <div class="gameButtomBg_title">
        联系我们
        <div class="gameButtomBg_line"></div>
        <p>如果您有任何问题，请联系neurips2024@alibaba.com</p>
        <div class="ourIcon"></div>
      </div>
      <div class="previous_box4_title1">
        论文引用格式
        <div class="previous_box4_title1_line"></div>
        <p>如果您有任何问题，请联系neurips2024@alibaba.com</p>
      </div>
    </div> -->
<!--
    <div v-if="isShow">
      <div class="black"></div>
      <div class="dialog">
        <div class="dialog_title">结果上传</div>
        <div class="dialog_cha" @click="dialogIsntShow"></div>
        <div class="content">
          <form action="post" name="upLoadFile">
            <input type="file" name="file" id="file" />
            <div class="fileClickDiv" @click="uploadFile">点击上传文件</div>
            <div class="selectFile">
              <div class="selectTitle">已选择文件</div>
              <div class="fileNmae" v-html="fileNameHtml"></div>
              <input name="submit" type="submit" id="submit" value="提交" />
            </div>
          </form>
        </div>
      </div>
    </div> -->

    <div v-if="isShow">
      <div class="black"></div>
      <div class="dialog">
        <div class="dialog_title">我的申请记录</div>
        <div class="dialog_cha" @click="closeIsShow"></div>

        <div class="content">
          <table>
            <thead>
              <tr>
                <th>时间</th>
                <th>队伍名称</th>
                <th>状态</th>
                <th>结果</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-show="resIsShow_res">
      <div class="res_black"></div>
      <div class="res_dialog">
        <div class="res_dialog_title">结果上传</div>
        <div class="res_dialog_cha" @click="dialogIsntShow"></div>
        <div class="res_content">
          <form action="post" name="upLoadFile">
            <input type="file" name="file" id="file" />
            <div class="res_fileClickDiv" @click="uploadFile">点击上传文件</div>
            <div class="res_selectFile">
              <div class="res_selectTitle">已选择文件</div>
              <div class="res_fileNmae" v-html="fileNameHtml"></div>
              <input name="submit" type="submit" id="submit" value="提交" />
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import mainUnits from '@/views/mainUnits.vue'
import axios from 'axios'
export default {
  name: 'sub2Page',
  components: {
    mainUnits
  },
  data () {
    return {
      rankList: [],
      isShow: false,
      getFilename: '',
      fileDivValue: '',
      fileNameHtml: '',
      resIsShow_res: false
    }
  },
  created () {
    this.fetchRankData()
  },
  methods: {
    fetchRankData () {
      axios.get('/media/csv/sub3Page.csv?t=' + Date.now())
        .then(res => {
          this.rankList = this.parseCSV(res.data)
        })
        .catch(err => {
          console.error('Failed to load rank data', err)
        })
    },
    parseCSV (csvText) {
      const lines = csvText.trim().split(/\r?\n/)
      const result = []
      const headers = lines[0].split(',')
      for (let i = 1; i < lines.length; i++) {
        if (!lines[i]) continue
        const obj = {}
        const currentLine = lines[i].split(',')
        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentLine[j]
        }
        result.push(obj)
      }
      return result
    },
    apply () {
      this.$store.commit('applyShowFn3', true)
    },
    closeIsShow () {
      this.isShow = false
    },
    dialogIsntShow () {
      this.resIsShow_res = false
    },
    checkResfn () {
      this.resIsShow_res = true
    },
    uploadFile () {
      const fileDiv = document.querySelector('#file')
      fileDiv.click()
      setInterval(() => {
        if (fileDiv.value !== this.fileDivValue) {
          const index = fileDiv.value.lastIndexOf('\\')
          // console.log(index)
          this.fileDivValue = fileDiv.value.slice(index + 1)
          this.fileNameHtml = this.fileDivValue
          // clearInterval(timmer)
        }
      }, 500)
    },
    tips () {
      alert('网站正在建设中，请进首页联系群获取报名邮箱')
    }
  }
//   submit_res () {
//     const fileDiv = document.querySelector('#file')
//     fileDiv.innerHTML = ''
//   }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTZCHK";
  src: url("/src/assets/font/FZLTCHJW.TTF") format("truetype"); /* 使用webpack的别名&#126;@指向src目录 */
  font-weight: normal;
  font-style: normal;
}
.paihang_box {
  background: url(/src/assets/img/bg_for_paihang1.jpg) no-repeat;
  width:100%;
  height: 7.0rem;
}
.paihang_title {
  text-align: center;
    padding-top: 0.9rem;
    // width: 7.27rem;
    height: 0.3rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
}
.content1 {
  width: 90%;
  height: 8.2rem;
  // box-shadow: rgba(99, 99, 99, 0.2) 0px 0.02rem 0.08rem 0px;
  margin: 0 auto;
  position: relative;
  table {
    margin: 0.3rem auto;
    text-align: center;
    font-size: 0.14rem;
    font-family: FZLTZCHK;
    width: 100%;
    border: 0.02rem solid #a2d0ff;
    border-collapse: collapse;
    border-radius: 0.12rem;
    thead tr th,
    tbody tr td {
      padding: 0.05rem;
      border: 0.02rem solid #a2d0ff;
    }
    thead tr th {
      border: 0;
      color: #ffffff;
      background-color: #9dceff;
    }
    tbody tr td {
      a {
        border-bottom: 1px solid red;
        cursor: pointer;
        color: red;
      }
    }
  }
}
.des {
  font-size: 0.15rem;
}
.previous_box1 {
  width: 100%;
  height: 12rem;
  background: url(/src/assets/img/previous_box1_bg_half.png) no-repeat;
  background-size: 100% 100%;
  .previous_box1_title1 {
    text-align: center;
    padding-top: 0.9rem;
    // width: 7.27rem;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    .previous_box1_title1_line {
      margin: 0.15rem auto;
      margin-left: 4.4rem;
      width: 7rem;
      height: 0.05rem;
      background: url(/src/assets/img/title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box1_title1_content {
    width: 11.5rem;
    // background-color: pink;
    margin: 1rem auto;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.17rem;
      text-indent: 2em;
      line-height: 0.3rem;
    }
    .previous_png1 {
      background: url(/src/assets/img/previous1.png) no-repeat;
      background-size: 100% 100%;
      width: 8.5rem;
      height: 3.3rem;
      margin: 0 auto;
      margin-top: 0.5rem;
    }
  }
  .previous_box1_title2 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
  }
  .previous_box1_title2_line {
    margin: 0.15rem auto;
    width: 2.15rem;
    height: 0.05rem;
    background: url(/src/assets/img/game_title1_line.png) no-repeat;
    background-size: 100% 100%;
  }
  .previous_box1_title2_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.7rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.23rem;
      line-height: 0.46rem;
      span {
        color: #2266ff;
        &::before {
          display: inline-block;
          content: "";
          width: 0.2rem;
          height: 0.25rem;
          transform: translateY(0.05rem);
          background: url(/src/assets/img/list_style2.png) no-repeat;
          margin-right: 0.15rem;
          background-size: 100% 100%;
        }
      }
    }
    .chart {
      background: url(/src/assets/img/chart.png) no-repeat;
      background-size: 100% 100%;
      width: 4.4rem;
      height: 4.4rem;
      margin: 0.8rem auto;
    }
  }
}
.previous_box2 {
  width: 100%;
  height: 5rem;
  background: url(/src/assets/img/previous_box2_bg.png) no-repeat;
  background-size: 100% 100%;
  .previous_box2_title1 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1.6rem;
  }
  .previous_box2_title1_line {
    margin: 0.15rem auto;
    width: 2.15rem;
    height: 0.05rem;
    background: url(/src/assets/img/game_title1_line.png) no-repeat;
    background-size: 100% 100%;
  }
  .previous_box2_title1_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.7rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.2rem;
      line-height: 0.36rem;
      text-align: center;
      span {
        color: #2266ff;
      }
    }
  }
  .previous_box2_title2 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1.8rem;
    .previous_box2_title2_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box2_title2_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.7rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.2rem;
      line-height: 0.36rem;
      text-indent: 2em;
    }
  }
  .shouldDo {
    ul {
      transform: translateX(-0.63rem);
      width: 12rem;
      height: 2.1rem;
      padding: 0.4rem;
      // margin: 0 auto;
      margin-top: 0.2rem;
      // background-color: pink;
      li {
        float: left;
        list-style: none;
        margin: 0 0.2rem;
        height: 1.2rem;
        width: 1.2rem;
        background: radial-gradient(circle, #e0efff 0%, #f5f9ff 100%);
        box-shadow: 0 0.05rem 0.38rem 0.05rem #b1c6e8;
        border-radius: 0.22rem 0.22rem 0.22rem 0.22rem;
        padding: 0.2rem 0.4rem;
        text-align: center;
        p {
          //   font-size: 0.2rem;
          font-family: FZLTZCHK;
          //   width: 1rem;
          color: #5d8fff;
          text-indent: 0;
          &:first-child {
            transform: translateY(0.23rem);
          }
        }
        // transform: translateY(0.2rem);
      }
    }
  }
}
.previous_box3 {
  width: 100%;
  height: 25.6rem;
  background: url(/src/assets/img/previous_box3_bg.png) no-repeat;
  background-size: 100% 100%;
  .bigBtnBox {
    width: 11.5rem;
    // background-color: pink;
    margin: 0 auto;
    padding-top: 1rem;
    .btns {
      float: left;
      width: 2.8rem;
      height: 1rem;
      background: linear-gradient(#e0efff, #f5f9ff);
      margin: 0.35rem;
      transform: translateX(0.5rem);
      box-shadow: 0 0.05rem 0.38rem 0.05rem #b1c6e8;
      .btn1,
      .btn2,
      .btn3 {
        font-size: 0.32rem;
        color: #2266ff;
        // padding: 0.3rem;
        text-align: center;
        line-height: 1rem;
        font-family: FZLTZCHK;
        cursor: pointer;
      }
      .btn1 {
        transform: translateY(-0.1rem);
        &::before {
          display: inline-block;
          content: "";
          background: url(/src/assets/img/icon1.png) no-repeat;
          background-size: 100% 100%;
          height: 0.7rem;
          width: 0.6rem;
          transform: translateY(0.25rem);
          margin-right: 0.2rem;
        }
      }
      .btn2 {
        transform: translateY(-0.2rem);
        &::before {
          display: inline-block;
          content: "";
          background: url(/src/assets/img/icon2.png) no-repeat;
          background-size: 100% 100%;
          height: 0.8rem;
          width: 0.8rem;
          transform: translateY(0.25rem);
          margin-right: 0.2rem;
        }
      }
      .btn3 {
        transform: translateY(-0.02rem);
        &::before {
          display: inline-block;
          content: "";
          background: url(/src/assets/img/icon3.png) no-repeat;
          background-size: 100% 100%;
          height: 0.63rem;
          width: 0.74rem;
          transform: translateY(0.22rem);
          margin-right: 0.2rem;
        }
      }
    }
  }
  .previous_box3_title1 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 2.8rem;
    .previous_box3_title1_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box3_title1_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.8rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.2rem;
      line-height: 0.36rem;
      text-indent: 2em;
    }
  }
  .previous_box3_title2 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1rem;
    .previous_box3_title2_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .arrange {
    margin: 0 auto;
    width: 12rem;
    ul {
      transform: translateX(-0.4rem);
      width: 12rem;
      height: 2.1rem;
      padding: 0.4rem;
      // margin: 0 auto;
      margin-top: 0.4rem;
      // background-color: pink;
      li {
        float: left;
        list-style: none;
        margin: 0 0.2rem;
        height: 1.6rem;
        width: 1.2rem;
        background: radial-gradient(circle, #e0efff 0%, #f5f9ff 100%);
        box-shadow: 0 0.05rem 0.38rem 0.05rem #b1c6e8;
        border-radius: 0.22rem 0.22rem 0.22rem 0.22rem;
        padding: 0.2rem 0.4rem;
        text-align: center;
        p {
          font-size: 0.2rem;
          font-family: FZLTZCHK;
          // width: 1.1rem;
          color: #5d8fff;
          text-indent: 0;
          &:first-child {
            transform: translateY(0.1rem);
          }
        }
        // transform: translateY(0.2rem);
        div {
          font-size: 0.2rem;
          font-family: FZLTZCHK;
          text-indent: 0;
          transform: translateY(0.4rem);
          text-align: center;
          font-style: italic;
        }
        .frist_title {
          padding-top: 0.1rem;
        }
      }
      .frist_div div {
        font-size: 0.2rem;
        font-family: FZLTZCHK;
        text-indent: 0;
        transform: translateY(0.1rem);
        text-align: center;
        font-style: italic;
      }
    }
  }
  .previous_box3_title3 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1rem;
    .previous_box3_title3_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box3_content {
    width: 11.4rem;
    // background-color: pink;
    margin: 0 auto;
    div {
      transform: translateX(-0.112rem);
      display: inline-block;
      height: 3rem;
      width: 3rem;
      // background-color: #2266ff;
      margin: 0.4rem 0.35rem;
      .bonus1 {
        background: url(/src/assets/img/bonus1.png) no-repeat;
        background-size: 100% 100%;
        .bonus1-text { /* 新增类来专门设置p元素的样式 */
          position: absolute; /* 绝对定位p元素 */
          top: 50%; /* 将p元素的上边缘放置在bonus1元素垂直中心 */
          left: 50%; /* 将p元素的左边缘放置在bonus1元素水平中心 */
          transform: translate(-50%, -50%); /* 使用transform来居中p元素 */
          width: 100%; /* 使p元素的宽度与bonus1相同 */
          text-align: center; /* 水平居中文本 */
          color: #000000; /* 设置文本颜色 */
          font-size: 0.2rem; /* 设置字体大小 */
        }
      }
      .bonus2 {
        background: url(/src/assets/img/bonus2.png) no-repeat;
        background-size: 100% 100%;
        .bonus2-text { /* 新增类来专门设置p元素的样式 */
          position: absolute; /* 绝对定位p元素 */
          top: 50%; /* 将p元素的上边缘放置在bonus1元素垂直中心 */
          left: 50%; /* 将p元素的左边缘放置在bonus1元素水平中心 */
          transform: translate(-50%, -50%); /* 使用transform来居中p元素 */
          width: 100%; /* 使p元素的宽度与bonus1相同 */
          text-align: center; /* 水平居中文本 */
          color: #000000; /* 设置文本颜色 */
          font-size: 0.2rem; /* 设置字体大小 */
        }
      }
      .bonus3 {
        background: url(/src/assets/img/bonus3.png) no-repeat;
        background-size: 100% 100%;
        .bonus3-text { /* 新增类来专门设置p元素的样式 */
          position: absolute; /* 绝对定位p元素 */
          top: 50%; /* 将p元素的上边缘放置在bonus1元素垂直中心 */
          left: 50%; /* 将p元素的左边缘放置在bonus1元素水平中心 */
          transform: translate(-50%, -50%); /* 使用transform来居中p元素 */
          width: 100%; /* 使p元素的宽度与bonus1相同 */
          text-align: center; /* 水平居中文本 */
          color: #000000; /* 设置文本颜色 */
          font-size: 0.2rem; /* 设置字体大小 */
        }
      }
    }
  }
}
.gameButtomBg {
  background: url(/src/assets/img/perv_buttomBg.png) no-repeat;
  background-size: 100% 100%;
  height: 8rem;
  width: 100%;
  margin-top: -3rem;
  .gameButtomBg_title {
    text-align: center;
    transform: translateY(-3rem);
    // width: 6rem;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
  }
  .gameButtomBg_line {
    margin: 0.15rem auto;
    width: 2.15rem;
    height: 0.05rem;
    background: url(/src/assets/img/game_title1_line.png) no-repeat;
    background-size: 100% 100%;
  }
  p {
    margin-top: 0.45rem;
    height: 0.24rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.22rem;
    color: #000000;
    line-height: 0.43rem;
  }
  .ourIcon {
    width: 2.03rem;
    height: 2rem;
    margin: 0 auto;
    margin-top: 0.8rem;
    background: #d2e9fe;
    box-shadow: 0.02rem 0.02rem 0.06rem 0.01rem rgba(130, 195, 255, 0.55);
    border-radius: 0.39rem;
  }
  .previous_box4_title1 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 2rem;
    .previous_box4_title1_line {
      margin: 0.15rem auto;
      width: 3rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
.box3 {
    position: relative;
    width: 100%;
    height: 43rem;
    background: url(/src/assets/img/bg3.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    min-width: var(--content-width);
    .title4 {
      text-align: center;
      margin-top: 0.9rem;
      // width: 7.27rem;
      height: 0.38rem;
      font-family: FZLTZCHK;
      font-weight: normal;
      font-size: 0.4rem;
      color: #333333;
      line-height: 0.38rem;
      .title4_line {
        margin: 0.15rem auto;
        width: 8.8rem;
        height: 0.05rem;
        background: url(/src/assets/img/title4_line.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .dw,
    .title5,
    .title6,
    .hzdw,
    .zcdw {
      margin: 0.8rem auto;
      text-align: center;
      // width: 1.4rem;
      height: 0.33rem;
      font-family: FZLTZCHK;
      font-weight: normal;
      font-size: 0.34rem;
      color: #333333;
      line-height: 0.68rem;
      text-shadow: 0.01rem 0.07rem 0 rgba(183, 162, 208, 0.55);
    }
    .slot1,
    .slot2,
    .slot3,
    .slot4 {
      margin: 0.5rem auto;
    }
    .cb,
    .xb {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: wrap;
      margin: 0 auto;
      width: 11.13rem;
      // background-color: pink;
      align-items: center;
      .div1 {
        //flex: 1;
        //margin: 0 auto;
        // text-align: center;
        flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        margin: 0 4.5rem; /* 修改这里，给 div 添加左右外边距 */
        left: 2rem;
        // background: url(/src/assets/img/title4_line.png) no-repeat;
      }
      .div2 {
        flex: 1;
        margin: 0 2.2rem;
        // text-align: center;
        // flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        // margin: 0 1.85rem; /* 修改这里，给 div 添加左右外边距 */
        // display: inline-block;
      }
      .div3 {
        flex: 1;
        margin: 0 auto;
        // text-align: center;
        // flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        // margin: 0 1.85rem; /* 修改这里，给 div 添加左右外边距 */
        // background-color: #2266ff;
        // display: inline-block;
      }
    }
  }

// 弹框控制
.dialog {
  height: 65%;
  width: 40%;
  max-height: 8rem;
  background-color: #fff;
  z-index: 3;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .content {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
    table {
      margin: 0.3rem auto;
      text-align: center;
      font-size: 0.14rem;
      font-family: FZLTZCHK;
      width: 100%;
      border: 0.02rem solid #a2d0ff;
      border-collapse: collapse;
      border-radius: 0.12rem;
      thead tr th,
      tbody tr td {
        padding: 0.05rem;
        border: 0.02rem solid #a2d0ff;
      }
      thead tr th {
        border: 0;
        color: #fff;
        background-color: #9dceff;
      }
      tbody tr td {
        a {
          border-bottom: 1px solid red;
          cursor: pointer;
          color: red;
        }
      }
    }
  }
  .dialog_title {
    font-size: 0.3rem;
    font-family: FZLTZCHK;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
  }
}
.black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.dialog_cha {
  position: absolute;
  top: 0.33rem;
  right: 0.33rem;
  height: 0.23rem;
  width: 0.23rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

// 上传结果弹框控制
.res_dialog {
  height: 10rem;
  width: 10rem;
  max-height: 350px;
  max-width: 458px;
  background-color: #fff;
  z-index: 5;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .res_content {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
  }
  .res_dialog_title {
    font-size: 0.3rem;
    font-family: FZLTZCHK;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
  }
}
.res_black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
}
.res_dialog_cha {
  position: absolute;
  top: 0.33rem;
  right: 0.33rem;
  height: 0.23rem;
  width: 0.23rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}
#file {
  display: none;
}
.res_fileClickDiv {
  position: absolute;
  text-align: center;
  width: 80%;
  height: 16%;
  // padding-top: 10%;
  line-height: 0.5rem;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-family: FZLTZCHK;
  font-size: 0.21rem;
  color: #fff;
  background-color: #74b9ff;
  border-radius: 0.08rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0 0.08rem 0.24rem;
  border: 0;
  cursor: pointer;
  &::before {
    display: inline-block;
    content: "";
    height: 0.25rem;
    width: 0.25rem;
    background: url(/src/assets/img/upLoadIcon.png) no-repeat;
    background-size: 100% 100%;
    transform: translateY(0.05rem);
    margin-right: 0.1rem;
  }
}

#submit {
  position: absolute;
  right: 0.1rem;
  bottom: 0.1rem;
  color: #fff;
  background-color: #74b9ff;
  border-radius: 0.08rem;
  font-size: 20%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 0.08rem 0.24rem;
  border: 0;
  height: 20%;
  width: 30%;
}

.res_selectFile {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  height: 60%;
  width: 80%;
  background-color: #fff;
  border-radius: 0.08rem;
  box-shadow: rgba(149, 157, 165, 0.4) 0px 0.08rem 0.24rem;
  border: 0;
  .res_selectTitle {
    position: absolute;
    top: 8%;
    left: 8%;
    font-size: 0.15rem;
    color: #454545;
    font-family: FZLTZCHK;
  }
  .res_fileNmae {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 20%;
    font-size: 20%;
    padding: 0 0.1rem;
    line-height: 0.4rem;
    border-radius: 0.08rem;
    font-family: FZLTZCHK;
    overflow: hidden;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 0.02rem 0.08rem 0px;
  }
}
.btn_apply {
  position: absolute;
  bottom: 0.2rem;
  right: 1rem;
  width: 1rem;
  height: 0.4rem;
  font-family: FZLTZCHK;
  background-color: #74b9ff;
  color: #fff;
  border-radius: 0.08rem;
//   margin-left: 1rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border: 0;
  margin-top: 1.5rem;
  cursor: pointer;
}
.btn_new {
  position: absolute;
  bottom: 0.2rem;
  right: -0.2rem;
  width: 1rem;
  height: 0.4rem;
  font-family: FZLTZCHK;
  background-color: #74b9ff;
  color: #fff;
  border-radius: 0.08rem;
  margin-left: 0.45rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border: 0;
  cursor: pointer;
}
.container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left {
  // display: flex;
  flex: 1;
  //margin-right: 2em;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
.right {
  flex: 1;
  margin-left: 2em;
}
.item {
  padding: 0.5rem;
  border-radius: 5px;
  margin: 0rem;
}
.item1 {
  flex: 1;
  padding: 0.5rem;
  // border-radius: 5px;
  margin: 0 auto;
  // background-color: pink;
  width: 3rem;
}
.doublename {
  display: flex;
}
.item2 {
  flex: 1;
  padding: 0.5rem;
  border-radius: 5px;
  margin: 0 auto;
  width: 3rem;
  // background-color: #2266ff;
}
.name1 {
  flex: 1;
  font-weight: bold;
  font-size: 0.2rem;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  // background-color: #2266ff;
  text-align: center;
  background-color: #5d8fff
}
.name {
  font-weight: bold;
  font-size: 0.2rem;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
  // background-color: #2266ff;
  text-align: center;
}
.item p {
  font-size: 0.15rem; /* 0.5rem 相当于 8px（假设默认字体大小为 16px） */
  // background-color: #14614c;
  text-align: center;
}
.item1 p {
  font-size: 0.15rem; /* 0.5rem 相当于 8px（假设默认字体大小为 16px） */
  // background-color: #14614c;
  text-align: center;
}
.item2 p {
  font-size: 0.15rem; /* 0.5rem 相当于 8px（假设默认字体大小为 16px） */
  // background-color: #14614c;
  text-align: center;
}
</style>
